import { DomainIncomeType } from "@porchpass/api-client";

/** Income types attached to employment records — filtered out of "Additional Income". */
export const EMPLOYMENT_INCOME_TYPES: ReadonlySet<string> = new Set([
  DomainIncomeType.IncomeBase,
  DomainIncomeType.IncomeBonus,
  DomainIncomeType.IncomeCommission,
  DomainIncomeType.IncomeOvertime,
]);

export const isNonEmploymentIncome = (inc: { income_type?: string }): boolean =>
  !EMPLOYMENT_INCOME_TYPES.has(inc.income_type as string);

/**
 * The backend creates a duplicate MAILING address whenever a CURRENT address
 * has isMailingAddress=true. Filter out MAILING addresses that match the
 * CURRENT address data — the CURRENT card already shows the "Mailing" badge.
 * Only keep MAILING addresses that are genuinely different (separate mailing).
 */
export const isMailingAddressDuplicateOfCurrent = (
  addr: {
    address_type?: string;
    street1?: string;
    street2?: string;
    city?: string;
    state?: string;
    zip_code?: string;
  },
  currentAddr:
    | {
        street1?: string;
        street2?: string;
        city?: string;
        state?: string;
        zip_code?: string;
      }
    | undefined,
): boolean => {
  if (addr.address_type !== "MAILING" || currentAddr == null) {
    return false;
  }
  return (
    addr.street1 === currentAddr.street1 &&
    addr.street2 === currentAddr.street2 &&
    addr.city === currentAddr.city &&
    addr.state === currentAddr.state &&
    addr.zip_code === currentAddr.zip_code
  );
};
